/**
 * Maps an internal Transloco language id to the locale code the backend expects.
 *
 * The backend uses the country-style code `cz` for Czech, whereas Transloco (and
 * ISO 639-1) uses the language code `cs`. Keep this mapping as the single source of
 * truth for that translation instead of scattering string replacements across the app.
 */
const API_LOCALE_MAP: Record<string, string> = { cs: 'cz' };

/**
 * Translates an internal Transloco lang id (e.g. `cs`) into the locale code the backend
 * expects (e.g. `cz`). Unmapped languages are returned unchanged.
 */
export const toApiLocale = (lang: string): string => API_LOCALE_MAP[lang] ?? lang;
